<template>
  <j-form-container :disabled="disabled">

    <a-tabs default-active-key="1" @change="tabChange">
      <a-tab-pane key="1" tab="BU層級資訊" :forceRender="true">
      </a-tab-pane>
      <a-tab-pane key="2" tab="PC層級資訊" :forceRender="true">
      </a-tab-pane>
      <a-tab-pane key="3" tab="法人資訊" :forceRender="true">
      </a-tab-pane>
    </a-tabs>

    <a-table ref="table" size="middle" :scroll="{ x: true }" bordered rowKey="id" :columns="columns"
      :dataSource="dataSource" :pagination="false" :loading="loading" class="j-table-force-nowrap"
      @change="handleTableChange">


    </a-table>
  </j-form-container>
</template>

<script>
import Vue from 'vue'
import { getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'YoyForm',
  // mixins: [JeecgListMixin],
  components: {
  },
  data() {
    return {
      url: {
        list: '/epi/expense/getBu'
      },
      queryParam: {
        accessToken: Vue.ls.get("accessToken"),
      },
      dataSource: [],
 
    }
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    record:{
      type:Object,
      default: {},
      required: false
    }
  },
  created() {
    this.tabChange('1')
  },
  methods: {
    handlerRequestBu() {
      this.loading = true
      const url = '/epi/expense/getBu'

      this.queryParam.yyyymm = this.record.yyyymm
      this.queryParam.sbg_code = this.record.sbg_code
      this.queryParam.fsi = this.record.fsi
      getAction(url, this.queryParam).then((res) => {
        this.loading = false
        if (res.success) {
          this.dataSource = res.result
        }
      })
      
    },

    handlerRequestPC() {
      this.loading = true
      const url = '/epi/expense/getPc'

      this.queryParam.yyyymm = this.record.yyyymm
      this.queryParam.sbg_code = this.record.sbg_code
      this.queryParam.fsi = this.record.fsi
      getAction(url, this.queryParam).then((res) => {
        this.loading = false
        if (res.success) {
          this.dataSource = res.result
        }
      })
      
    },

    handlerRequestSBG() {
      this.loading = true
      const url = '/epi/expense/getSBG'

      this.queryParam.yyyymm = this.record.yyyymm
      this.queryParam.sbg_code = this.record.sbg_code
      this.queryParam.fsi = this.record.fsi
      getAction(url, this.queryParam).then((res) => {
        this.loading = false
        if (res.success) {
          this.dataSource = res.result
        }
      })
      
    },

    handlerRequestBG() {
      this.loading = true
      const url = '/epi/expense/getBG'

      this.queryParam.yyyymm = this.record.yyyymm
      this.queryParam.bg_name = this.record.bg_name
      this.queryParam.fsi_name = this.record.fsi_name
      getAction(url, this.queryParam).then((res) => {
        this.loading = false
        if (res.success) {
          this.dataSource = res.result
        }
      })
      
    },

    buColumns() {
      return [
        {
          title: 'BU Code',
          align: 'center',
          width: 100,
          dataIndex: 'bu_code',
          ellipsis: true,
        },
        {
          title: 'BU名稱',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'bu_name',
        },
        {
          title: '會科編碼',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'fsi',
        },
        {
          title: '會科名稱',
          dataIndex: 'fsi_name',
          width: 100,
          ellipsis: true,
        },
        {
          title: '當月費用',
          dataIndex: 'amount_after_writeoff',
          width: 100,
        },
        {
          title: '當月費用占比',
          dataIndex: 'expense_percent_on_sbg',
          width: 100,
        },
        {
          title: 'YoY費用差異',
          dataIndex: 'year_diff',
          ellipsis: true,
          width: 100,
        },
        {
          title: 'YoY差異%',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'year_diff_percent',
        },
        {
          title: 'MoM費用差異',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'month_diff',
        },
        {
          title: 'MoM差異%',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'month_diff_percent',
        },
      ]
    },

    pcColumns() {
      return [
        {
          title: 'BU Code',
          align: 'center',
          width: 100,
          dataIndex: 'bu_code',
          ellipsis: true,
        },
        {
          title: 'BU名稱',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'bu_name',
        },
        {
          title: 'PC Code',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'pc_code',
        },
        {
          title: 'PC名稱',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'pc_name',
        },
        {
          title: '會科編碼',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'fsi',
        },
        {
          title: '會科名稱',
          dataIndex: 'fsi_name',
          width: 100,
          ellipsis: true,
        },
        {
          title: '當月費用',
          dataIndex: 'amount_after_writeoff',
          width: 100,
        },
        {
          title: '當月費用占比',
          dataIndex: 'expense_percent_on_sbg',
          width: 100,
        },
        {
          title: 'YoY費用差異',
          dataIndex: 'year_diff',
          ellipsis: true,
          width: 100,
        },
        {
          title: 'YoY差異%',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'year_diff_percent',
        },
        {
          title: 'MoM費用差異',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'month_diff',
        },
        {
          title: 'MoM差異%',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'month_diff_percent',
        },
      ]
    },

    sbgColumns() {
      return [
        {
          title: '法人 Code',
          align: 'center',
          width: 100,
          dataIndex: 'sbg_code',
          ellipsis: true,
        },
        {
          title: '法人名稱',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'sbg_name',
        },
        {
          title: '會科編碼',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'fsi',
        },
        {
          title: '會科名稱',
          dataIndex: 'fsi_name',
          width: 100,
          ellipsis: true,
        },
        {
          title: '當月費用',
          dataIndex: 'amount_after_writeoff',
          width: 100,
        },
        {
          title: '當月費用占比',
          dataIndex: 'expense_percent_on_sbg',
          width: 100,
        },
        {
          title: 'YoY費用差異',
          dataIndex: 'year_diff',
          ellipsis: true,
          width: 100,
        },
        {
          title: 'YoY差異%',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'year_diff_percent',
        },
        {
          title: 'MoM費用差異',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'month_diff',
        },
        {
          title: 'MoM差異%',
          align: 'center',
          width: 100,
          ellipsis: true,
          dataIndex: 'month_diff_percent',
        },
      ]
    },

    tabChange(key) {
      console.log(key);
      if(key === '1') {
        this.handlerRequestBu()
        this.columns = this.buColumns()
      } else if(key === '2') {
        this.handlerRequestPC()
        this.columns = this.pcColumns()
      } else {
        this.handlerRequestSBG()
        this.columns = this.sbgColumns()
      }
    },
  },
}
</script>